export default {
  setFeatures(features) {
    this.authAppleEnabled = features?.authAppleEnabled || false;
    this.authEmailEnabled = features?.authEmailEnabled || false;
    this.authGoogleEnabled = features?.authGoogleEnabled || false;
    this.paymentsEnabled = features?.paymentsEnabled || false;
    this.paymentsApplePayEnabled = features?.paymentsApplePayEnabled || false;
    this.paymentsGooglePayEnabled = features?.paymentsGooglePayEnabled || false;
    this.profileCountersEnabled = features?.profileCountersEnabled || false;
    this.defaultLanguage = features?.defaultLanguage || 'en';
  },
};
